export const introDialogue = {
  type: "dialogue",
  nextSequence: "guidedBattle",
  orbPosition: {
    left: "50%",
    top: "25%",
    scale: 2,
  },
  steps: [
    {
      id: "step1",
      text: `Initializing contact…`,
    },
    {
      id: "step2",
      text: `Contact established... 


	  Ah. You made it. I was beginning to wonder if any would answer the call.`,
    },
    {
      id: "step3",
      text: `Welcome, Traveler — to The Infinity.
			A realm once teeming with balance and power… now on the brink of collapse.`,
    },
    {
      id: "step4",
      text: `Time fractures. Energy fades. And the once-unbreakable flow between realities is crumbling.`,
    },
    {
      id: "step5",
      text: `They called me I.O. — the Infinity Orb. I was created to protect this place, to guide new Travelers like you. But something has disturbed the core…`,
    },
    {
      id: "step6",
      text: `The characters, the decks, the monsters — they're not just data. They’re living echoes of this fractured world... and they need you.`,
    },
    {
      id: "step7",
      text: `I’ve scanned your energy… you've got a funny name.
	  
	  But hey — I’ve seen worse. There was a Traveler once named... “BeefCheeks42.”`,
    },
    {
      id: "step8",
      text: `Anyway. You’ve got potential. And with your help, we might just have a shot at restoring balance.`,
    },
    {
      id: "step9",
      text: `But first… you’ll need to learn how to survive.`,
    },
    {
      id: "step10",
      text: `Let me show you how to wield your deck, command your cards, and unleash your strength.`,
    },
    {
      id: "step11",
      text: `Time is short. And the Infinity waits for no one.`,
    },
  ],
};

export const battleTutorial = {
  type: "guidedBattle",
  nextSequence: "firstDeck",
  orbPosition: {
    right: "10%",
    top: "17%",
    scale: 1,
  },
  steps: [
    {
      id: "inspectOpponent",
      text: `Okay let's get you battle ready!
	  
	  Before you rush in swinging — let's take a look at your opponent by tapping their platform. (click players on board to inspect)`,
    },
    {
      id: "explainOpponentStats",
      text: `Luna has 6 Attack, and buffed her  Accuracy to 10! 
	  ...You've only got 5 Health. 
	  That means… if she land a hit — *you’re fried*.`,
    },
    {
      id: "explainPlayerTurn",
      text: `You get two actions per turn. Think of it like... time splitting in your favor.`,
    },
    {
      id: "switchToDefense",
      text: `Chicken Wizard isn't built for heavy attacks, so let's prep for a win!
	  First, switch to Defense Mode - Click the "fist" icon on the bottom right and change your stance.`,
    },
    {
      id: "selectDefenseCard",
      text: `Nice. Notice how you have a shield!?...
	  Now we need to play a Defense card to boost your shield. 
	  We need you still standing when they swing.
	  Select your Fortify Elixir card.`,
    },
    {
      id: "playDefenseCard",
      text: `Now apply it to yourself in 3 easy steps!
	  1. Select "Play It".
	  2. Click on your platform.
	  3. Confirm the action.`,
    },
    {
      id: "cardPLayConfirmation",
      text: `Boom! Now we're ready to defend!`,
    },
    {
      id: "cpuBuffs",
      text: `Heads up... they’re powering up. Looks like they’ve buffed their Attack.`,
    },
    {
      id: "cpuAttacks",
      text: `Here it comes — brace yourself!`,
    },
    {
      id: "playAccuracyCard",
      text: `Still breathing? Good. Looks like we've got to end things early!
	   Play an Accuracy card to increase your chances of landing a hit to 100%!`,
    },
    {
      id: "playerAttack",
      text: `Locked in?!... Let’s end this! 
	  Launch an Attack and take 'em out.
	  1. Click the "fist" icon
	  2. Select Attack
	  3. Select your target
	  4. Spin the Attack Wheel!`,
    },
    {
      id: "winPrompt",
      text: `Boom! That’s how you do it. One match down — countless to go. You’re catching on fast, Traveler.`,
    },
    {
      id: "movingOn",
      text: `Now there's just one more thing I want to show ya!`,
    },
  ],
};

export const firstDeck = {
  type: "deckBuilder",
  nextSequence: null,
  orbPosition: {
    left: "5%",
    bottom: "30%",
    scale: 2,
  },
  steps: [
    {
      id: "collectRewards",
      text: `Let’s start with something shiny. Open your starter rewards by clicking the gift icon at the top of the screen and claiming your rewards.`,
    },
    {
      id: "confirmCards",
      text: `Ooooh, nice pull! These cards will form the core of your destiny — or, at least, your first few wins. Now head to the Decksmith building to forge your first deck.`,
    },
    {
      id: "done",
      text: `Not bad, not bad at all. Your first deck is locked in! You’re officially ready to step into the Infinity — no turning back now.`,
    },
  ],
};

export const tutorialPlayers = [
  {
    id: "bot_3",
    ready: true,
    name: "BotPlayer 3",
    isBot: true,
    character: {
      imageFin:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Faza-fin.png?alt=media&token=b876fece-76c0-4265-8a96-58d0f49a133e",
      stance: "defense",
      element: "void",
      price: "",
      bgColor1: "#d7abf0",
      isDead: true,
      description: "Very high Accuracy means her attacks land often",
      imageStart:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Faza-start.png?alt=media&token=fa32c03e-f860-49b3-8550-68e8db9d1f99",
      startingDefense: 3,
      attackName: "Eclipse",
      ipProviderStripeId: "acct_1RVKttQtgrQNp4Pd",
      attack: 4,
      health: 0,
      startingAttack: 4,
      startingHealth: 5,
      defense: 0,
      id: "zQvMFzozSPKQLxMtHHUu",
      accuracy: 7,
      collectionName: "BIG Neighbors",
      availableForPurchase: false,
      season: "1",
      buffs: {
        attack: [],
        health: [],
        defense: [],
        accuracy: [],
      },
      name: "Aza",
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FAza.png?alt=media&token=bde6e739-5de5-471c-8a00-8d467c60030b",
      tokenId: "",
      finite: false,
      bgColor2: "#ae52e0",
      startingAccuracy: 7,
      rarity: "Uncommon",
    },
  },
  {
    level: "26",
    record: {
      losses: 90,
      dnfs: 0,
      wins: 19,
      ties: 0,
    },
    isBot: false,
    name: "test_player",
    id: "test_player_id",
    character: {
      startingAttack: 6,
      bgColor1: "#ffde41",
      startingHealth: 6,
      ipProviderStripeId: "acct_1RVKfNR4Xl8963KX",
      name: "Chicken Wizard",
      imageBG:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fbackgrounds%2Fchicken-wizard-bg.png?alt=media&token=c4b3793f-5dd3-4655-8a63-eb4730dcf7bd",
      accuracy: 8,
      tokenId: "",
      isDead: false,
      collectionName: "Reds (The Wilds)",
      defense: 2,
      availableForPurchase: true,
      startingAccuracy: 8,
      amountOwned: 1,
      imageFin:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fred-wizard-fin.png?alt=media&token=ac6e1e21-e371-4c9d-acb9-2afb5ab7fbe3",
      attackName: "Burnout",
      description: "High accuracy for spell casting—he doesn't miss. ",
      buffs: {
        accuracy: [],
        health: [],
        attack: [],
        defense: [],
      },
      type: "character",
      rarity: "Legendary",
      attack: 6,
      finite: false,
      startingDefense: 5,
      _uuid: "1749334459563-0.885107380369471",
      imageStart:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fred-wizaed-start.png?alt=media&token=5ee16fcc-72da-40cf-8bba-2d3e0aa9569a",
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FCluckles.png?alt=media&token=d2eefc9f-6f6e-4dad-b21a-1f24c1f25006",
      stance: "attack",
      id: "1IpMfLJ0olM9QnhiVfjH",
      health: 5,
      bgColor2: "#f25c2a",
      season: "1",
      boosts: {
        defense: 0,
        accuracy: 0,
        health: 0,
        attack: 0,
      },
      price: "699",
      element: "fire",
    },
    avatar:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fwhite.png?alt=media&token=4057c10a-9333-44da-8e89-9f06282fb184",
    ready: true,
    xp: 5045,
  },
  {
    name: "BotPlayer 4",
    id: "bot_4",
    character: {
      rarity: "Uncommon",
      accuracy: 7,
      startingDefense: 3,
      name: "Aza",
      startingAccuracy: 7,
      collectionName: "BIG Neighbors",
      attackName: "Eclipse",
      element: "void",
      stance: "defense",
      bgColor2: "#ae52e0",
      isDead: true,
      health: 0,
      season: "1",
      finite: false,
      description: "Very high Accuracy means her attacks land often",
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FAza.png?alt=media&token=bde6e739-5de5-471c-8a00-8d467c60030b",
      id: "zQvMFzozSPKQLxMtHHUu",
      bgColor1: "#d7abf0",
      ipProviderStripeId: "acct_1RVKttQtgrQNp4Pd",
      attack: 4,
      price: "",
      startingHealth: 5,
      tokenId: "",
      availableForPurchase: false,
      startingAttack: 4,
      imageFin:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Faza-fin.png?alt=media&token=b876fece-76c0-4265-8a96-58d0f49a133e",
      imageStart:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Faza-start.png?alt=media&token=fa32c03e-f860-49b3-8550-68e8db9d1f99",
      defense: 0,
      buffs: {
        health: [],
        accuracy: [],
        attack: [],
        defense: [],
      },
    },
    isBot: true,
    ready: true,
  },
  {
    isBot: true,
    character: {
      attackName: "Dragon Beam",
      collectionStripeId: "acct_1RVKq7Qv02UoBQuk",
      startingDefense: 4,
      isDead: false,
      health: 5,
      defense: 4,
      startingAccuracy: 6,
      season: "1",
      availableForPurchase: false,
      rarity: "Rare",
      price: "",
      element: "air",
      attack: 6,
      description:
        "Precision-based play style. Disrupts her enemies with high Accuracy",
      ipProviderStripeId: "acct_1RVfuOR97RFLrQFz",
      collectionName: "Dragon Punks",
      bgColor1: "#e33f70",
      imageStart:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fluna-start.png?alt=media&token=5768fadc-b187-421e-9ff3-aca58f15eb6a",
      bgColor2: "#f8f8b4",
      imageFin:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fluna-fin.png?alt=media&token=66253abe-05d8-4f4b-bf60-1d0766d5e518",
      stance: "attack",
      tokenId: "",
      finite: false,
      name: "Luna",
      buffs: {
        defense: [],
        accuracy: [
          {
            amt: 4,
            duration: 0,
          },
        ],
        attack: [],
        health: [],
      },
      startingHealth: 5,
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FLuna.png?alt=media&token=0d786060-e506-4f7f-8ea5-008fa6a81f0f",
      accuracy: 6,
      startingAttack: 6,
      id: "Wm8bH5OwEPliw71FrZ0R",
    },
    ready: true,
    id: "bot_1",
    name: "BotPlayer 1",
  },
  {
    isBot: true,
    name: "BotPlayer 5",
    character: {
      bgColor1: "#fdfdc9",
      startingAttack: 5,
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FZaporia.png?alt=media&token=43f5b726-8125-4de6-9a3c-0b863e8dd00a",
      description: "Not the best Accuracy, but she has good Defense and Attack",
      imageFin:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fzaporia-fin.png?alt=media&token=4cb657f5-1925-4d9a-b718-30daacff182b",
      rarity: "Uncommon",
      isDead: true,
      price: "499",
      startingDefense: 7,
      ipProviderStripeId: "acct_1RV59VQxYqbeeLwW",
      accuracy: 2,
      attackName: "Wild Spark",
      name: "Zaporia",
      finite: false,
      buffs: {
        attack: [],
        defense: [],
        accuracy: [],
        health: [],
      },
      collectionStripeId: "acct_1RVKq7Qv02UoBQuk",
      attack: 5,
      element: "electric",
      imageStart:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fzaporia-start.png?alt=media&token=e36d0bb6-b816-45e8-8a79-95729d8eff60",
      availableForPurchase: true,
      defense: 0,
      startingAccuracy: 2,
      stance: "defense",
      ipProviderTestStripeId: "acct_1RWBTsR8nIfv18Hy",
      season: "1",
      collectionName: "Dragon Punks",
      bgColor2: "#b97413",
      startingHealth: 5,
      tokenId: "",
      health: 0,
      id: "M43tnvW20fVl7C3xCuWS",
    },
    ready: true,
    id: "bot_5",
  },
  {
    isBot: true,
    name: "BotPlayer 2",
    character: {
      collectionStripeId: "acct_1RVKq7Qv02UoBQuk",
      season: "1",
      element: "void",
      defense: 0,
      accuracy: 3,
      id: "VdvuLPzuOMUyZbcDQRb3",
      availableForPurchase: false,
      imageStart:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fxaro-start.png?alt=media&token=3a83bb34-5968-4a54-b4f0-1b941ccd6b41",
      isDead: true,
      name: "Xaro",
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FXar.png?alt=media&token=f50c136a-91ee-4daa-91b0-434c9ed8357c",
      startingAccuracy: 3,
      finite: false,
      startingAttack: 6,
      attack: 6,
      startingHealth: 5,
      startingDefense: 4,
      buffs: {
        attack: [],
        defense: [],
        health: [],
        accuracy: [],
      },
      description: "A volatile void dragon with low Accuracy but strong Attack",
      stance: "defense",
      health: 0,
      price: "",
      rarity: "Common",
      bgColor1: "#bb5afa",
      attackName: "Oblivion Surge",
      tokenId: "",
      ipProviderStripeId: "acct_1RVfuOR97RFLrQFz",
      bgColor2: "#ca3253",
      collectionName: "Dragon Punks",
      imageFin:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fxaro-fin.png?alt=media&token=14422f8c-4ecc-4bc3-ba80-af6817a2bd46",
    },
    ready: true,
    id: "bot_2",
  },
];

export const testHands = {
  test_player_id: [
    {
      turnsActive: "Instant",
      season: "1",
      craftNeeded: "Sightstone Fragment",
      id: "ug999ZOONr7pIIOr6cxH",
      areaAffected: ["Accuracy"],
      finite: "TRUE",
      max: "2",
      availForPurchase: false,
      price: "",
      craftAmount: "3",
      type: "Infinity",
      name: "Seer’s Lens",
      effect: "Increases Accuracy by 4",
      _uuid: "1743844855541-0.6932300064158051",
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FSeer%E2%80%99s%20Lens.png?alt=media&token=90b78d30-014e-4dd5-b0b6-161dfb18ac1b",
      description: "A polished artifact made from fused Sightstone Fragments.",
      bgColor1: "#ffffff",
      bgColor2: "#0aafe6",
      amountOwned: 30,
    },
    {
      max: "2",
      bgColor1: "#feb8f7",
      name: "Refined Rejuvenation Elixir",
      finite: "TRUE",
      craftAmount: "2",
      season: "1",
      _uuid: "1743844870613-0.570411507927095",
      id: "FnMjUN9ZgMQkfmSuV550",
      type: "Infinity",
      turnsActive: "2 turns",
      areaAffected: ["Health"],
      availForPurchase: false,
      effect: "Restores 3 health over 2 turns.",
      bgColor2: "#6548cb",
      description:
        "A meticulously refined elixir that accelerates natural healing, crafted from merged Rejuvenation Elixirs.",
      craftNeeded: "Rejuvenation Elixir",
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FRefined%20Rejuvenation%20Elixir.png?alt=media&token=76b72b8d-95cf-460a-b403-796acee42043",
      price: "",
      amountOwned: 24,
    },
    {
      craftAmount: "null",
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FTrickshot%20Tonic.png?alt=media&token=3baf1be4-0db6-4570-8bb0-86b3888c5d3c",
      id: "e1Nrxlq3WzM74ce0flMB",
      bgColor1: "#fee138",
      finite: "FALSE",
      type: "Infinity",
      max: "3",
      price: "",
      _uuid: "1743844564310-0.7855761595511495",
      areaAffected: ["Accuracy"],
      turnsActive: "Instant",
      description: "A flashy brew favored by confident marksmen.",
      season: "1",
      effect: "Increases Accuracy by 3",
      bgColor2: "#fdc130",
      availForPurchase: false,
      name: "Trickshot Tonic",
      craftNeeded: "null",
      amountOwned: 20,
    },
    {
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FRefined%20Rejuvenation%20Elixir.png?alt=media&token=76b72b8d-95cf-460a-b403-796acee42043",
      craftAmount: "2",
      price: "",
      max: "2",
      bgColor1: "#feb8f7",
      season: "1",
      amountOwned: 24,
      id: "FnMjUN9ZgMQkfmSuV550",
      name: "Refined Rejuvenation Elixir",
      finite: "TRUE",
      bgColor2: "#6548cb",
      effect: "Restores 3 health over 2 turns.",
      _uuid: "1743844870613-0.570411507927095",
      turnsActive: "2 turns",
      type: "Infinity",
      areaAffected: ["Health"],
      availForPurchase: false,
      description:
        "A meticulously refined elixir that accelerates natural healing, crafted from merged Rejuvenation Elixirs.",
      craftNeeded: "Rejuvenation Elixir",
    },
    {
      craftNeeded: "null",
      craftAmount: "null",
      availForPurchase: false,
      price: "",
      type: "Infinity",
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FFortify%20Elixir.png?alt=media&token=e8ff379c-a78b-453e-b285-113feb0f06df",
      id: "08ahgmfrUXkqjuZrw5YW",
      bgColor2: "#2b1b53",
      amountOwned: 4,
      areaAffected: ["Defense"],
      name: "Fortify Elixir",
      _uuid: "1744575369692-0.7526905129141483",
      season: "1",
      max: "7",
      finite: "FALSE",
      effect: "Increases Defense by 2",
      description: "A glowing elixir known for its defensive enhancements.",
      turnsActive: "Instant",
      bgColor1: "#be4dd8",
    },
  ],
  bot_1: [
    {
      id: "R3HylH1GS1orDq3bqN5Q",
      description: "Iron-weighted gloves that pack a stronger punch.",
      effect: "Increases Attack by 1",
      areaAffected: ["Attack"],
      turnsActive: "Instant",
      availForPurchase: false,
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FIronclaw%20Gloves.png?alt=media&token=ecf8b279-1dc3-4a4c-867a-f926bff981df",
      max: "10",
      bgColor1: "#995c1b",
      season: "1",
      finite: "FALSE",
      bgColor2: "#cbbea5",
      craftAmount: "null",
      craftNeeded: "null",
      name: "Ironclaw Gloves",
      price: "",
    },
    {
      id: "Zaq3fRKNhPALXKYqDNgm",
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FFrostglint%20Liquid.png?alt=media&token=b624bad1-5cbc-435a-9e2f-b9636c12e56b",
      season: "1",
      areaAffected: ["Accuracy"],
      name: "Frostglint Liquid",
      turnsActive: "Instant",
      effect: "Increases Accuracy by 1",
      craftNeeded: "null",
      price: "",
      max: "10",
      bgColor2: "#0edbfd",
      craftAmount: "null",
      description: "A chilled potion that clears the mind and eye.",
      availForPurchase: false,
      finite: "FALSE",
      bgColor1: "#ffffff",
    },
    {
      id: "Dgp9LCQ1LsCFHSwMvD9m",
      description:
        "A rare serum that momentarily grants the strength of stone.",
      price: "",
      bgColor2: "#b7ab84",
      turnsActive: "Instant",
      bgColor1: "#5c512a",
      name: "Stoneflesh Serum",
      finite: "FALSE",
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FStoneflesh%20Serum.png?alt=media&token=5786b743-1bfb-4c0a-8e3c-6e53105d9e76",
      availForPurchase: false,
      effect: "Increases Defense by 3",
      areaAffected: ["Defense"],
      season: "1",
      craftAmount: "null",
      craftNeeded: "null",
      max: "3",
    },
    {
      turnsActive: "Instant",
      season: "1",
      craftNeeded: "Sightstone Fragment",
      id: "ug999ZOONr7pIIOr6cxH",
      areaAffected: ["Accuracy"],
      finite: "TRUE",
      max: "2",
      availForPurchase: false,
      price: "",
      craftAmount: "3",
      type: "Infinity",
      name: "Seer’s Lens",
      effect: "Increases Accuracy by 4",
      _uuid: "1743844855541-0.6932300064158051",
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FSeer%E2%80%99s%20Lens.png?alt=media&token=90b78d30-014e-4dd5-b0b6-161dfb18ac1b",
      description: "A polished artifact made from fused Sightstone Fragments.",
      bgColor1: "#ffffff",
      bgColor2: "#0aafe6",
      amountOwned: 30,
    },
    {
      id: "ca2HjhNsqGBe84PU1OpH",
      effect: "Increases Accuracy by 2",
      name: "Moonlight Scope",
      turnsActive: "Instant",
      max: "7",
      areaAffected: ["Accuracy"],
      season: "1",
      craftAmount: "null",
      availForPurchase: false,
      price: "",
      finite: "FALSE",
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FMoonlight%20Scope.png?alt=media&token=c751b025-eaa2-4dfa-a2f3-180737411d62",
      bgColor1: "#ffffff",
      description: "A scope enchanted under moonlight, enhancing targeting.",
      craftNeeded: "null",
      bgColor2: "#6658d0",
    },
  ],
};
